import { useState } from "react";
import { EditorState, convertToRaw, convertFromHTML, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";

const MIN_HTML_CONTENT_LENGTH = 9;

const createEditorFromHtml = (html?: string) =>
  html && html.length >= MIN_HTML_CONTENT_LENGTH
    ? EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(html).contentBlocks,
          convertFromHTML(html).entityMap
        )
      )
    : EditorState.createEmpty();

const toHtml = (state: EditorState) =>
  draftToHtml(convertToRaw(state.getCurrentContent()))
    .replace(/&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, " ")
    .trim()
    .replaceAll("_self", "_blank");

export interface EditorField {
  editorState: EditorState;
  setEditorState: (s: EditorState) => void;
  html: string;
  setHtml: (h: string) => void;
}

export const useNewFlowEditors = (
  whatWentWell?: string,
  whatCouldBeDifferent?: string,
  overallFeedback?: string
): { whatWentWell: EditorField; whatCouldBeDifferent: EditorField; overallFeedback: EditorField; toHtml: (s: EditorState) => string } => {
  const [wwwEditor, setWwwEditor] = useState(() => createEditorFromHtml(whatWentWell));
  const [wcbdEditor, setWcbdEditor] = useState(() => createEditorFromHtml(whatCouldBeDifferent));
  const [ofEditor, setOfEditor] = useState(() => createEditorFromHtml(overallFeedback));

  const [wwwHtml, setWwwHtml] = useState("");
  const [wcbdHtml, setWcbdHtml] = useState("");
  const [ofHtml, setOfHtml] = useState("");

  return {
    whatWentWell: { editorState: wwwEditor, setEditorState: setWwwEditor, html: wwwHtml, setHtml: setWwwHtml },
    whatCouldBeDifferent: { editorState: wcbdEditor, setEditorState: setWcbdEditor, html: wcbdHtml, setHtml: setWcbdHtml },
    overallFeedback: { editorState: ofEditor, setEditorState: setOfEditor, html: ofHtml, setHtml: setOfHtml },
    toHtml,
  };
};
